import { UserTeamAccess } from 'types';
import { authApi } from '../apis';

export const retriedUserTeamAccessVerification = async (
	times = 3,
	wait = 1500,
): Promise<UserTeamAccess | undefined> => {
	try {
		const result = await authApi.post('/autodesk/user/team/access');
		return result.data;
	} catch (e) {
		if (times > 0) {
			await new Promise(resolve => setTimeout(resolve, wait));
			return retriedUserTeamAccessVerification(times - 1, wait * 2);
		}
		return undefined;
	}
};
